/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_TitleInputs */

const cs_import_progress_title = /** @type {(inputs: Import_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Průběh importu`)
};

const en_import_progress_title = /** @type {(inputs: Import_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import progress`)
};

/**
* | output |
* | --- |
* | "Import progress" |
*
* @param {Import_Progress_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_title = /** @type {((inputs?: Import_Progress_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_title(inputs)
	return cs_import_progress_title(inputs)
});